// removed by extract-text-webpack-plugin
module.exports = {"successErrorModal":"qempo_SuccessErrorModal_successErrorModal-wHEDpQq","yogi":"qempo_SuccessErrorModal_yogi-1ahGhsb","orange":"qempo_SuccessErrorModal_orange-5IWJolX","lightBlue":"qempo_SuccessErrorModal_lightBlue-2s1p95v","modalLoading":"qempo_SuccessErrorModal_modalLoading-1xuyiV3"};


//////////////////
// WEBPACK FOOTER
// ./src/elements/SuccessErrorModal/SuccessErrorModal.scss
// module id = 1339
// module chunks = 0